/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_L2Inputs */

const en_mk_term_l2 = /** @type {(inputs: Mk_Term_L2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`  Packet: 2 criteria · files: src/forms/onboarding.tsx · tier Core`)
};

const id_mk_term_l2 = /** @type {(inputs: Mk_Term_L2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`  Packet: 2 kriteria · file: src/forms/onboarding.tsx · tier Utama`)
};

/**
* | output |
* | --- |
* | "Packet: 2 criteria · files: src/forms/onboarding.tsx · tier Core" |
*
* @param {Mk_Term_L2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_l2 = /** @type {((inputs?: Mk_Term_L2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_L2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_l2(inputs)
	return en_mk_term_l2(inputs)
});